import { queryOptions } from "@tanstack/react-query";
import { axiosClient } from "auth-sdk";

import { CUSTOMER_BUSINESS_MODEL_API } from "../../components/constants";
import type { BusinessModelData } from "../../types";

export const getCustomerBusinessModelQueryOptions = (customerDomain: string) => {
  const url = CUSTOMER_BUSINESS_MODEL_API.replace(":customerSlug", customerDomain);
  return queryOptions({
    queryKey: [url],
    queryFn: () => axiosClient.get<BusinessModelData>(url),
    select: (data: { data: BusinessModelData }) => data.data,
    refetchOnMount: "always",
  });
};
